import React from 'react';

import TableCell from '@material-ui/core/TableCell';

import TableRow from '@material-ui/core/TableRow';

const MasterItem = ({ name, description, weight, quantity }) => {

  return (
    <React.Fragment>
      <TableRow key={name}>
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell>
          {description}
        </TableCell>
        <TableCell>
          {weight}
        </TableCell>
        <TableCell align="right">
          {quantity}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default MasterItem;